export default "__VITE_ASSET__BNtAJPLh__"